export default "__VITE_ASSET__D2cKGN2F__"